export class LegalNotes {
  constructor(data) {
    this.id = data.id;
    this.description = data.description;
    this.description_eng = data.description_eng;
  }
}
